(() => {
  const universeRoot = document.querySelector('[data-tl-universes]');
  const familySections = [...document.querySelectorAll('[data-tl-family-section]')];
  const totalCount = Number(universeRoot?.dataset.totalCount || familySections[0]?.dataset.totalCount || 0);

  // Shopify Liquid exposes at most 50 collection products to editorial sections.
  // Below that threshold, the server-rendered markup is already complete and no request is needed.
  if (!universeRoot || totalCount <= 50 || totalCount > 250) return;

  const collectionUrl = universeRoot.dataset.collectionUrl;

  const eligibleForTags = (product, tags) => {
    const requestedTags = tags.split('|').filter(Boolean);
    const hasTag = Array.isArray(product.tags) && requestedTags.some((tag) => product.tags.includes(tag));
    const hasSellableVariant = (product.variants || []).some(
      (variant) => variant.available && Number(variant.price) > 0
    );
    const quoteOnly = (product.tags || []).includes('AIZ_PRICE_A_COMPLETER') || (product.variants || []).some((variant) => Number(variant.price) <= 0);
    return hasTag && (hasSellableVariant || quoteOnly);
  };

  fetch(`${collectionUrl}/products.json?limit=250`, { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error('TOPLINK catalog request failed');
      return response.json();
    })
    .then(({ products = [] }) => {
      document.querySelectorAll('[data-tl-universe-card]').forEach((card) => {
        const matches = products.filter((product) => eligibleForTags(product, card.dataset.tags || ''));
        const minimum = Number(card.dataset.minimum || 1);
        card.hidden = matches.length < minimum;
        const count = card.querySelector('[data-tl-count]');
        if (count) count.textContent = `${matches.length} produit${matches.length > 1 ? 's' : ''}`;
        const media = card.querySelector('.tl-universe-card__media');
        if (media && !media.querySelector('img, .px-universe-symbol') && matches[0]?.images?.[0]?.src) {
          const image = document.createElement('img');
          image.src = `${matches[0].images[0].src}${matches[0].images[0].src.includes('?') ? '&' : '?'}width=760`;
          image.alt = matches[0].images[0].alt || matches[0].title;
          image.loading = 'lazy';
          media.appendChild(image);
        }
      });

      familySections.forEach((section) => {
        const matches = products.filter((product) => eligibleForTags(product, section.dataset.tags || ''));
        const minimum = Number(section.dataset.minimum || 1);
        section.hidden = matches.length < minimum || !section.querySelector('[data-tl-family-products] .tl-product-card');
      });
    })
    .catch(() => {
      // Keep the complete server-rendered collection grid available if the enhancement cannot load.
    });
})();
